import {
  CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  Injectable,
  LOCALE_ID,
  NgModule,
} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { AppRoutingModule } from './app.routes';
import { SharedModule } from './shared/shared.module';
import { StateModule } from './state.module';
import { MaterialModule } from './material.module';
import { NgxsModule } from '@ngxs/store';
import { NgxMaskModule } from 'ngx-mask';
import { NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin';
import { NgxsResetPluginModule } from 'ngxs-reset-plugin';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppState, stateKeys } from './store/app.state';
import { AuthGuard } from './shared/auth/auth.guard';
import { AuthService } from './store/auth/auth.service';
import { InstanaService } from './shared/services/instana/instana.service';
import { environment } from '../environments/environment';
import { LoadingInterceptor } from './shared/interceptors/loading.interceptor';
import { IpsModule } from './ips/ips.module';
import { MatTableModule } from '@angular/material/table';
import { TvoModule } from './tvo/tvo.module';
import { ErrorInterceptor } from './shared/interceptors/error.interceptor';
import { TvfModule } from './tvf/tvf.module';

@Injectable()
export class InstanaErrorHandler implements ErrorHandler {
  handleError(error: any) {
    const exception = error.originalError || error;

    window['ineum']('reportError', exception);
  }
}

registerLocaleData(localePt, 'pt');

const Locale = { provide: LOCALE_ID, useValue: 'pt' };
const InstanaError = { provide: ErrorHandler, useClass: InstanaErrorHandler };
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CoreModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    StateModule,
    FormsModule,
    MatTableModule,
    MaterialModule,
    FlexLayoutModule,
    NgxMaskModule.forRoot({
      dropSpecialCharacters: false,
    }),
    NgxsModule.forRoot(AppState, { developmentMode: !environment.production }),
    NgxsStoragePluginModule.forRoot({
      key: stateKeys,
      storage: StorageOption.SessionStorage,
    }),
    NgxsResetPluginModule.forRoot(),
    NgxSpinnerModule,
    IpsModule,
    TvoModule,
    TvfModule,
  ],
  exports: [NgxMaskModule, RouterModule],
  providers: [
    AuthGuard,
    AuthService,
    InstanaService,
    Locale,
    InstanaError,
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
